import { ButtonProps, LinkButtonSettings } from '@almbrand/button';
import { CtaGroupProps } from '@almbrand/ctagroup';

export const ctaGroupMargins = (ctaMarginTop: string, ctaMarginBottom: string): string => {
	const marginTop = ctaMarginTop !== 'none' ? `pt-${ctaMarginTop}` : '';
	const marginBottom = ctaMarginBottom !== 'none' ? `pb-${ctaMarginBottom}` : '';

	return `${marginTop} ${marginBottom}`.trim();
};

// Map button block coming from CMS "Features -> Blocks" structure
export const generateButtonArray = (buttons: Button[], ctaGroupMargins: string): CtaGroupProps => {
	if (!buttons || buttons.length === 0) {
		return null;
	}

	return {
		ctaGroup:
			buttons?.map((button) => {
				return {
					children: button?.title || '',
					buttonType: (button?.type === 'cta' ? button?.color : button?.type) as ButtonProps['buttonType'],
					linkButtonSettings: {
						href: button?.link?.url,
						target: button?.target as LinkButtonSettings['target'],
						title: button?.title,
					},
					trackingEvent: {
						event: 'trackNavigation',
						navigationAction: button?.title ?? '',
						navigationDestination: button?.link?.url ?? '',
						navigationType: 'call-to-action',
					},
				};
			}) || [],
		className: ctaGroupMargins,
	};
};

// Map button block coming from new CMS "Component Library" structure
export const mapCtaProps = (ctas: CtaProps[], onClick?: () => void, groupClassName?: string): CtaGroupProps => {
	if (!ctas || ctas.length === 0) {
		return null;
	}

	return {
		ctaGroup: ctas.map((cta) => {
			const { content } = cta;
			return {
				children: content?.label,
				buttonType: content?.buttonType as ButtonProps['buttonType'],
				linkButtonSettings: content?.linkButtonSettings && {
					href: content?.linkButtonSettings.url,
					target: content?.linkButtonSettings.target as LinkButtonSettings['target'],
					title: content?.linkButtonSettings.title,
				},
				trackingEvent: {
					event: 'trackNavigation',
					navigationAction: content?.label ?? '',
					navigationDestination: content?.linkButtonSettings?.url ?? 'modal',
					navigationType: 'call-to-action',
				},
				onClick: !content?.linkButtonSettings && onClick,
			};
		}),
		className: groupClassName,
	};
};
